import React, { useEffect, useState } from "react";
import "./Setting.css";
import axios from "axios";

import { COMPANY_URLS } from "../../../Utils/Company_App_Urls";

export default function ResetNotification() {
  const [notificatonSetting, setNotificationSetting] = useState({
    security: false,
    jobalert: false,
    emailNotification: false,
    applicationstatus: false,
  });

  const handleChangeNotification = (type) => {
    setNotificationSetting((prev) => ({
      ...prev,
      [type]: !prev[type],
    }));
  };

  const notificationOption = [
    {
      option: "security",
      label: "Security Alert",
      description: "Be alerted of any unusual activity on your account.",
    },
    {
      option: "job alert",
      label: "Job Alert",
      description:
        "Stay informed about new job opportunities that match your preferences.",
    },
    {
      option: "emailNotification",
      label: "Email Notification",
      description: "Get Every Notification Through Email",
    },
    {
      option: "applicationstatus",
      label: "Application Status",
      description:
        "Receive updates on the status of your job application, from submission to offer.",
    },
  ];

  const handleJobNotificationUpdate = (value) => {
    const body = {
      status: value,
    };

    try {
      axios
        .patch(COMPANY_URLS.jobNotificationOnOff, body, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((res) => {})
        .catch((err) => {
          console.error(err);
        });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    handleJobNotificationUpdate(notificatonSetting?.jobPost);
  }, [notificatonSetting?.jobPost]);

  return (
    <div className="notification_main">
      <div className="reset-pass-title mb-4">
        <h1>Change Notification Setting</h1>
        <p>Customize How You Stay Informed and Connected</p>
      </div>
      {notificationOption.map((data, idx) => (
        <div
          className="toggle_group row d-flex justify-content-between mb-3"
          key={idx}
        >
          <div className="notification-items col-8 flex-grow-1">
            <p>{data.label}</p>
            <p>{data.description}</p>
          </div>
          <label className="switch col-3">
            <input
              type="checkbox"
              checked={notificatonSetting[data.option]}
              onChange={() => handleChangeNotification(data.option)}
            />
            <span className="slider round"></span>
          </label>
        </div>
      ))}
      <div className="btn_group_reset d-flex gap-5 justify-content-between align-items-center mt-5 flex-wrap border-0 p-0">
        <button>Cancel</button>
        <button type="submit">Save Changes</button>
      </div>
    </div>
  );
}
